import React, { useState, useRef, useEffect } from 'react'
import { Validaciones, Encriptar } from '@renedelangel/helpers';

// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';
import Modal from '../../../_layout/genericComponents/Modal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';

// material-ui icons
import Add from "@material-ui/icons/Add";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import { RiSurveyLine } from "react-icons/ri";
import Mail from '@material-ui/icons/Mail';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import VisibilityIcon from '@material-ui/icons/Visibility';

import { NetworkError } from "../../../_layout/genericComponents/Metodos";

//import Preguntas from './preguntas';
import * as Consultas from './Consultas.js';
import * as ConsultasDominios from '../../../querys/Dominios';
import { seleccionArea } from '../../../querys/Areas';
import * as Permisos from '../Permisos';

import { ftObtenerEjerciciosFiltrado } from '../../../helpers/rutinas/metodos/rutinasGenerales';

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar, handleAlertMutationGeneric, handleAlertGeneric } from '../../../_layout/helpers/handles';
import { info, danger, success, primary, black } from '../../../_layout/helpers/colores';


import moment from 'moment';

import PlantillaEncuesta from '../PlantillaEncuesta';

const { trim } = Validaciones;

function Encuesta() {

    let now = moment().year();


    const { token } = useSelector(state => state.login);

    const cleanState = {
        encuestaID: null,
        encuesta: "",
        areaID: "",
        correo: "",
        dominio: ""
    };
    const cleanErrorState = {
        encuesta: { error: false, helperText: "" },
        areaID: { error: false, helperText: "" },
        correo: { error: false, helperText: "" },
        dominio: { error: false, helperText: "" }
    }


    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [state, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [seleccionables, setSeleccionables] = useState(false);
    const [openEnviarCorreo, setOpenEnviarCorreo] = useState(false);
    const [openVisualizarPregunta, setOpenVisualizarPregunta] = useState(false);
    const [stateData, setStateData] = useState({});
    const [openPreguntas, setOpenPreguntas] = useState(false);
    const [stFiltros, setFiltros] = useState({ ejercicio: now, encuestaID: null });
    // Encuestas (folios) del ejercicio del filtro
    const [stEncuestas, setEncuestas] = useState([]);
    const [openGenerar, setOpenGenerar] = useState(false);
    const [stObservaciones, setObservaciones] = useState("");
    // La tabla toma el valor inicial de sus filtros solo al montarse: para preseleccionar un folio
    // se vuelve a montar (key) con ese folio como valor inicial
    const [stTablaKey, setTablaKey] = useState(0);
    const [stEncuestaDefault, setEncuestaDefault] = useState(null);
    // Ejercicio y folios de la última carga, para decidir si se preselecciona el primer folio
    const refUltimaCarga = useRef({ ejercicio: null, folios: [] });

    let titleAccion = state.encuestaID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} Sección`;

    const encuestaRef = useRef(null);
    const areaIDRef = useRef(null);

    let acciones = [
        {
            
            icono: VisibilityIcon,
            id: "pdf",
            color: success,
            descripcion: "Ver Sección",
            parametros: [{ campo: "encuestaID" }, { campo: "encuesta" }, { campo: "ejercicio" }, { campo: "seccionID" }],
            disabled: { multiseleccion: true },
            onClick: ({ encuestaID, encuesta, ejercicio, seccionID }) => { setOpenVisualizarPregunta(true); setStateData({ encuestaID, encuesta, ejercicio, seccionID, accion: "VerSeccion" }) }
        },
        {
            
            icono: Mail,
            id: "EnviarEncuesta",
            color: info,
            descripcion: "Enviar Encuesta",
            parametros: [{ campo: "encuestaID" }, { campo: "encuesta" }, { campo: "ejercicio" }, { campo: "seccionID" }],
            disabled: { multiseleccion: true },
            onClick: ({ encuestaID, encuesta, ejercicio, seccionID }) => { setOpenEnviarCorreo(true); setStateData({ encuestaID, encuesta, ejercicio, seccionID, accion: "EnviarCorreo"}) }
        }];

    let botones = [
        {
           
            icono: Add,
            color: success,
            descripcion: "Generar Encuesta",
            onClick: () => { setObservaciones(""); setOpenGenerar(true); },
            disabled: { multiseleccion: true }
        },
        // {
        //     accionID: [7],
        //     icono: PictureAsPdfIcon,
        //     color: "success",
        //     descripcion: "Imprimir Encuesta",
        //     onClick: () => ftImprimirEncuesta()
        // },
        {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        },
        {
          
            icono: AssignmentTurnedInIcon,
            color: "primary",
            descripcion: "Revisar / Imprimir Encuesta",
            onClick: () => ftRevisarEncuesta()
        },
        {
           
            icono: Close,
            color: "danger",
            descripcion: "Eliminar Encuesta",
            onClick: () => ftEliminarEncuesta()
        }
    ];

    function ftAlertaError(descripcion) {
        setAlert({
            descripcion,
            title: "¡Una disculpa!",
            tipo: danger,
            msjConfirmacion: "Aceptar",
            onConfirm: () => setAlert(null)
        });
    }

    // Encuesta sobre la que trabajan Revisar / Imprimir y Eliminar: la del filtro de folio,
    // o la única del ejercicio si no se eligió folio
    async function ftEncuestaSeleccionada() {
        let ejercicio = parseInt(stFiltros.ejercicio);
        let encuestaID = Number(stFiltros.encuestaID) || null;
        try {
            let { listado: encuestas = [] } = await Consultas.tablaEncuesta({ filtro: { ejercicio, count: null, pagina: 1, limite: 100000 } }, token) || {};
            if (encuestaID) {
                let encuesta = encuestas.find(e => Number(e.encuestaID) === encuestaID);
                if (encuesta) return encuesta;
                ftAlertaError('La encuesta seleccionada ya no existe; seleccione otro folio');
            }
            else if (encuestas.length === 1) return encuestas[0];
            else if (encuestas.length === 0) ftAlertaError('No existe una encuesta generada para este ejercicio');
            else ftAlertaError(`Hay ${encuestas.length} encuestas en el ejercicio ${ejercicio}; seleccione el folio de la encuesta`);
        } catch ({ message }) {
            ftAlertaError(message);
        }
        return null;
    }

    async function ftImprimirEncuesta(){
        let encuesta = await ftEncuestaSeleccionada();
        if (!encuesta) return;
        setStateData({ encuestaID: parseInt(encuesta.encuestaID), ejercicio: encuesta.ejercicio, seccionID: null });
        setOpenVisualizarPregunta(true);
    }


    async function ftRevisarEncuesta(){
        let encuesta = await ftEncuestaSeleccionada();
        if (!encuesta) return;
        setStateData({ encuestaID: parseInt(encuesta.encuestaID), ejercicio: encuesta.ejercicio, seccionID: null, estatus: encuesta.estatus, accion: "RevisarEncuesta" });
        setOpenPreguntas(true);
    }


    async function GenerarEncuesta() {
        try {
            let observaciones = trim(stObservaciones);
            if (observaciones.length > 200) throw new Error("Las observaciones no deben exceder 200 caracteres");
            let encuesta = await Consultas.generarEncuesta({ ejercicio: stFiltros.ejercicio, observaciones: observaciones || null }, token);
            setOpenGenerar(false);
            setActualizar(!actualizar);
            setAlert({
                descripcion: `Se generó correctamente la encuesta ${encuesta && encuesta.folio ? encuesta.folio + " " : ""}para el ejercicio ${stFiltros.ejercicio}`,
                title: "Encuesta",
                tipo: success,
                msjConfirmacion: "Aceptar",
                showCancel: false,
                onConfirm: () => setAlert(null)
            });
        } catch ({ message }) {
            ftAlertaError(message);
        }
    }

    async function ftEliminarEncuesta() {
        let encuesta = await ftEncuestaSeleccionada();
        if (!encuesta) return;
        handelAlertEliminar({
            setAlert,
            mensaje: ` la encuesta ${encuesta.folio} del ejercicio ${encuesta.ejercicio}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { encuestaID: encuesta.encuestaID }, asyncDelete: EliminarEncuesta
            })
        });
    }

    // Si la eliminada era la del filtro, al recargar los folios se selecciona el primero
    async function EliminarEncuesta(parametros) {
        await Consultas.deleteEncuesta(parametros, token);
    }

    const infoTabla = {
        botones,
        acciones,
        loader,
        actualizar,
        id: "encuestaID",
        color: primary,
        title: "Secciones de Encuesta",
        iconTable: <RiSurveyLine />,
        headers: [
            { variable: "encuestaID", descripcion: "encuestaID", hide: true },
            { variable: "seccionID", descripcion: "seccionID", hide: true },
            { variable: "ejercicio", descripcion: "Ejercicio" },
            { variable: "folio", descripcion: "Folio" },
            { variable: "descripcion", descripcion: "Descripción" },
            { variable: "enviada", descripcion: "Correo enviado" },
            { variable: "pendienteRespuesta", descripcion: "Pendiente de Respuesta" }
        ],
        alineacion: [{ columnas: [1, 2, 4, 5], alineacion: "center" }],
        responsiveTitle: ["descripcion"],
        selectFilter: [
            {
                campo: "ejercicio", title: "Ejercicio",
                retorna: "number", /* limpiarFiltro: "Todos", */
                defaultValue: Number(stFiltros.ejercicio) || now,
                data: seleccionables.Ejercicios ? seleccionables.Ejercicios : [], grid: { md: 3, lg: 3 },
                // Al cambiar de ejercicio se limpia el folio, porque pertenece al ejercicio anterior
                funcionC: (valor, setSeleccionFiltro) => {
                    setFiltros(filtros => ({ ...filtros, encuestaID: null }));
                    setSeleccionFiltro(seleccionFiltro => ({ ...seleccionFiltro, encuestaID: null }));
                }
            },
            {
                campo: "encuestaID", title: "Encuesta (folio)",
                retorna: "number",
                limpiarFiltro: "Todas",
                placeholder: "Seleccionar folio",
                defaultValue: stEncuestaDefault,
                data: stEncuestas, grid: { md: 4, lg: 4 }
            }

        ],
        formato: [
            { columnas: ["enviada"], tipo: "estatus" }
        ],
        accionesEffect: 
        [
            // { botones: ["pdf"], ocultar: (data) => data["pendienteRespuesta"].value == 'NO' ? false : true },
            // { botones: ["EnviarEncuesta"],  ocultar: (data) => data["pendienteRespuesta"].value !== "NO"  ? false : true  },
            // { botones: ["pdf"], ocultar: (data) => data["descripcion"].value === 'Firmas' ? true : false },
            { botones: ["EnviarEncuesta"],  ocultar: (data) => data["descripcion"].value === "Firmas"  ? true : false  }
        ]
    }

    const inputs = [
        {
            id: "Arriba",
            tipo: "fieldset",
            grid: { lg: 12 },
            inputs: [
                {
                    disabled,
                    id: "encuesta",
                    value: state.encuesta,
                    error: errorState.encuesta.error,
                    success: state.encuesta && !errorState.encuesta.error ? true : undefined,
                    helperText: errorState.encuesta.helperText,
                    inputRef: encuestaRef,
                    title: "Sección *",
                    placeholder: "Capture la sección",
                    grid: { md: 8, lg: 8 },
                    onChange: ({ target: { value } }) => {
                        handleChange(value.charAt(0).toUpperCase() + value.slice(1), "encuesta")
                    },
                    onKeyDown: () => { return; }
                },
                {
                    disabled,
                    id: "areaID",
                    value: state.areaID,
                    error: errorState.areaID.error,
                    success: state.areaID && !errorState.areaID.error ? true : undefined,
                    helperText: errorState.areaID.helperText,
                    inputRef: areaIDRef,
                    title: "Área *",
                    placeholder: "Seleccione el área",
                    grid: { md: 4, lg: 4 },
                    tipo: "select",
                    data: seleccionables.Areas,
                    onChange: ({ target: { value } }) => {
                        handleChange(value, "areaID")
                    },
                },
            ]
        }
    ];

    let accionesFormulario = [{
        accionID: state.encuestaID,
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: encuestaRef,
            mensajeCorrecto: `La sección se ${state.encuestaID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function handleCloseEnviarCorreo() {
        setOpenEnviarCorreo(false);
        setState({ ...cleanState });
    }

    function handleCloseVisualizarPregunta() {
        setOpenVisualizarPregunta(false);
        setState({ ...cleanState });
    }

    
    function handleCloseVerPreguntas() {
        setOpenPreguntas(false);
        setState({ ...cleanState });
    }

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleValidaciones({ encuesta, areaID }) {

        let error;
        let validaciones = [
            {
                condicion: !encuesta || trim(encuesta) === "",
                ref: encuestaRef, keyError: "encuesta",
                mensajeError: "Debe especificar la sección"
            },
            {
                condicion: encuesta.length > 200,
                ref: encuestaRef, keyError: "encuesta",
                mensajeError: "Número de caracteres capturados excedido."
            },
            {
                condicion: !areaID,
                ref: areaIDRef, keyError: "areaID",
                mensajeError: "Debe especificar la area"
            },
        ];
        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function ftGuardar() {
        async function ftGuardar() {

            let { encuestaID,
                areaID,
                encuesta } = state;

            let error = await handleValidaciones({
                encuesta,
                areaID
            });

            state["areaID"] = parseInt(areaID);
            delete state["correo"];
            delete state["dominio"];
            delete state["ejercicio"];
            if (error) return error;

            if (encuestaID) await Consultas.updateEncuesta(state, token);
            else await Consultas.addEncuesta(state, token);

        }
        return ftGuardar();
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key) { setState({ ...state, [key]: value }); }

    useEffect(() => {
        async function ftEffect() {
            try {
                let Areas = await seleccionArea({ filtro: {} }, token);
                let Ejercicios = await ftObtenerEjerciciosFiltrado(token);
                let Dominios = await ConsultasDominios.seleccionDominios({}, token);
                setSeleccionables({ Areas, Ejercicios, Dominios });

            } catch ({ message }) {
                setAlert({
                    descripcion: `Algunos datos necesarios para funcionar no se cargaron correctamente, intenta actualizar la página o verifica tu conexión a internet; a continuación se muestrán más detalles del error: ${NetworkError(message)}`,
                    title: "¡Una disculpa!",
                    tipo: danger,
                    msjConfirmacion: "Aceptar",
                    onConfirm: () => setAlert(null)
                });
            }
        } ftEffect();
    }, [actualizar]);

    // Folios del ejercicio para el filtro de encuesta. Se preselecciona el primero cuando cambia el
    // ejercicio, cuando el ejercicio pasa a tener encuestas o cuando la elegida ya no existe;
    // si el usuario eligió "Todas" se respeta
    useEffect(() => {
        async function ftEffect() {
            let ejercicio = parseInt(stFiltros.ejercicio);
            let encuestas = ejercicio ? await Consultas.seleccionEncuesta({ filtro: { ejercicio } }, token) : [];
            setEncuestas(encuestas);

            let folios = encuestas.filter(({ value }) => value).map(({ value }) => value);
            let seleccionada = Number(stFiltros.encuestaID) || null;
            let anterior = refUltimaCarga.current;
            refUltimaCarga.current = { ejercicio, folios };

            let preseleccionar = anterior.ejercicio !== ejercicio
                || anterior.folios.length === 0
                || (seleccionada && !folios.includes(seleccionada));
            if (!preseleccionar) return;

            let primera = folios.length > 0 ? folios[0] : null;
            if (primera === seleccionada) return;
            setEncuestaDefault(primera);
            setFiltros(filtros => ({ ...filtros, encuestaID: primera }));
            setTablaKey(key => key + 1);
        } ftEffect();
    }, [stFiltros.ejercicio, actualizar]);

    const inputsEnviarCorreo = [
        {
            disabled,
            id: "correo",
            value: state.correo,
            title: "Correo *",
            grid: { md: 6, lg: 6 },
            placeholder: "Capture el correo",
            onChange: ({ target: { value } }) => setState({ ...state, correo: value }),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "dominio",
            value: state.dominio,
            title: "Dominio *",
            placeholder: "Seleccione el dominio",
            tipo: "select",
            data: seleccionables.Dominios,
            grid: { md: 6, lg: 6 },
            onChange: ({ target: { value, name } }) => setState({ ...state, [name]: value }),
            onKeyDown: () => { return; }
        },
    ]

    const accionesFormularioEnviarCorreo = [{
        accionID: "EnviarCorreo",
        loader,
        disabled,
        icono: Mail,
        color: success,
        descripcion: "Enviar",
        onClick: () => EnviarCorreo()
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleCloseEnviarCorreo
    }];

    const inputsGenerar = [
        {
            id: "observaciones",
            value: stObservaciones,
            title: "Observaciones",
            placeholder: "Opcional; sirve para distinguir la encuesta de otras del mismo ejercicio",
            grid: { md: 12, lg: 12 },
            onChange: ({ target: { value } }) => setObservaciones(value),
            onKeyDown: () => { return; }
        }
    ];

    const accionesFormularioGenerar = [{
        icono: Add,
        color: success,
        descripcion: "Generar",
        onClick: () => GenerarEncuesta()
    }, {
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: () => setOpenGenerar(false)
    }];

    async function EnviarCorreo() {
        try {
            let validacorreo = state.correo.includes('@');
            if (trim(state.correo) === "" || validacorreo) throw new Error("Debe ingresar un correo valido");
            if (trim(state.dominio) === "") throw new Error("Debe ingresar un dominio");
            handleAlertMutationGeneric({
                token, setAlert, setActualizar, actualizar,
                parametros: { encuestaID: stateData.encuestaID, seccionID: stateData.seccionID, correo: state.correo + state.dominio, ejercicio: stateData.ejercicio },
                asyncMutation: Consultas.enviarEncuesta,
                mensajes: {
                    msjEspera: {
                        title: `Espere por favor`,
                        descripcion: `Enviando encuesta...`
                    },
                    msjCorrecto: {
                        title: `Correcto`,
                        descripcion: `La encuesta se ha enviado`
                    }
                }
            })
            handleCloseEnviarCorreo();
        } catch ({ message }) {
            setAlert({
                descripcion: message,
                title: "¡Una disculpa!",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null)
            });
        }
    }


    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    } else {
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    return (<>
        <Tabla
            key={stTablaKey}
            infoTabla={infoTabla}
            asyncData={Consultas.tablaEncuestaSecciones}
            token={token}
            setFiltrosAplicados={setFiltros}
            requiereFiltros={true}
            limiteRegInicial={25}
        />
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            maxWidth={false}
            acciones={accionesFormulario}
            focus={encuestaRef}
        />
        {
            openEnviarCorreo && <FormularioModal
                open={openEnviarCorreo}
                title={"Enviar por correo"}
                onClose={handleCloseEnviarCorreo}
                inputs={inputsEnviarCorreo}
                acciones={accionesFormularioEnviarCorreo}
            />
        }
        {
            openGenerar && <FormularioModal
                open={openGenerar}
                title={`Generar encuesta del ejercicio ${stFiltros.ejercicio}`}
                onClose={() => setOpenGenerar(false)}
                inputs={inputsGenerar}
                acciones={accionesFormularioGenerar}
            />
        }
        {
            openVisualizarPregunta && <Modal
            title = {''}
            onClose = {handleCloseVisualizarPregunta}
            >

                <PlantillaEncuesta
                info={
                    {
                    token,
                    encuestaID: stateData.encuestaID,
                    seccionID: stateData.seccionID,
                    ejercicio: stateData.ejercicio,
                    accion: stateData.accion
                    }
                }
                openFromEncuesta = {true}
                />

            </Modal> 
        }
        {
            openPreguntas && <Modal
            title = {''}
            onClose = {handleCloseVerPreguntas}
            >

                <PlantillaEncuesta
                info={
                    {
                    token,
                    encuestaID: stateData.encuestaID,
                    seccionID: stateData.seccionID,
                    ejercicio: stateData.ejercicio,
                    estatus: stateData.estatus,
                    accion: stateData.accion
                    }
                }
                openFromEncuesta = {true}
                agregarFirmas = {true}
                handleCloseVerPreguntas={handleCloseVerPreguntas}
                />

            </Modal> 
        }
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);

}

export default Encuesta;
